import './TemplateAllInstancesTable.css';
import React, { useState, useEffect } from 'react';
import { getOrganizationNameWithApiKey } from '../../../services/b2b-users-apiService';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';
import { toLocaleDateTime, truncateText } from '../../b2b-common/helpers';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const TemplateAllInstancesTable = ({ instances, ...rest }) => {
    const { t } = useB2BTranslation('b2b-social');
    const [organizationNames, setOrganizationNames] = useState({});

    useEffect(() => {
        const fetchOrganizationNames = async () => {
            const names = {};
            for (const instance of instances) {
                try {
                    const name = await getOrganizationNameWithApiKey(instance.socialPostInstanceOrganizationUUID);
                    names[instance.socialPostInstanceOrganizationUUID] = name;
                } catch (error) {
                    console.error('Error fetching organization name: ' + error.message);
                    names[instance.socialPostInstanceOrganizationUUID] = 'Error';
                }
            }
            setOrganizationNames(names);
        };

        fetchOrganizationNames();
    }, [instances]);

    const headers = [
        { label: t('Organization'), align: 'left' },
        { label: t('Instance name'), align: 'left' },
        { label: t('Instance description'), align: 'left' },
        { label: t('Creation'), align: 'center' },
        { label: t('Locale'), align: 'center' },
        { label: t('Privacy'), align: 'center' },
        { label: t('Expiration'), align: 'center' },
        { label: t('Visits'), align: 'center' },
        { label: t('Enabled'), align: 'center' },
    ];

    const rows = instances ? instances.map((instance) => ({
        id: instance.socialPostInstanceId,
        cells: [
            { content: organizationNames[instance.socialPostInstanceOrganizationUUID] || 'Loading...', align: 'left' },
            { content: instance.socialPostInstanceName, align: 'left' },
            { content: truncateText(instance.socialPostInstanceDescription, 10), align: 'left' },
            { content: toLocaleDateTime(instance.creationDate, true), align: 'center' },
            { content: instance.socialPostInstanceLocale, align: 'center' },
            { content: instance.socialPostInstancePrivacy, align: 'center' },
            { content: toLocaleDateTime(instance.socialPostInstanceExpirationDate, false), align: 'center' },
            { content: instance.socialPostInstanceVisits, align: 'center' },
            { content: instance.socialPostInstanceEnabled ? <CheckBox /> : <CheckBoxOutlineBlank />, align: 'center' },
        ],
    })) : [];

    return (
        <B2BTableInMemory
            headers={headers}
            rows={rows}
            className={'template-all-instances-table'}
            numRows={10}
            stickyHeader={true}
            {...rest}
        />
    );
}

export default TemplateAllInstancesTable;